import React from 'react';
import { Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { FaFileAlt, FaUser, FaBriefcase, FaCarAlt, FaHome } from 'react-icons/fa';

const ConfirmationForm = ({
    isActive,
    formData,
    handleChange,
    handlePrev,
    isSubmitting,
    vehicleAmount,
    monthlyPayment,
    term
}) => {
    return (
        <div id="notlar-form" className={isActive ? 'd-block' : 'd-none'}>
            <h4 className="form-section-title">
                <FaFileAlt className="me-2" /> Başvuru Onayı
            </h4>

            <div className="mb-4 p-3 bg-light rounded">
                <h5>Başvuru Özeti</h5>

                <div className="summary-item mt-3">
                    <h6><FaUser className="me-2" /> Kişisel Bilgiler</h6>
                    <Row>
                        <Col md={6}>
                            <p><strong>Ad Soyad:</strong> {formData.name} {formData.surname}</p>
                            <p><strong>T.C. Kimlik No:</strong> {formData.tcNumber}</p>
                            <p><strong>Doğum Tarihi:</strong> {formData.birthDate}</p>
                        </Col>
                        <Col md={6}>
                            <p><strong>Telefon:</strong> {formData.phone}</p>
                            <p><strong>E-posta:</strong> {formData.email}</p>
                            <p><strong>Eğitim:</strong> {formData.education}</p>
                        </Col>
                    </Row>
                </div>

                <div className="summary-item mt-3">
                    <h6><FaBriefcase className="me-2" /> İş Bilgileri</h6>
                    <Row>
                        <Col md={6}>
                            <p><strong>Meslek:</strong> {formData.occupation}</p>
                            <p><strong>Çalışma Şekli:</strong> {formData.employmentType}</p>
                            <p><strong>Aylık Gelir:</strong> ₺{formData.income}</p>
                        </Col>
                        <Col md={6}>
                            <p><strong>İşyeri:</strong> {formData.workplaceName}</p>
                            <p><strong>Çalışma Süresi:</strong> {formData.employmentDuration}</p>
                        </Col>
                    </Row>
                </div>

                <div className="summary-item mt-3">
                    <h6><FaCarAlt className="me-2" /> Araç Bilgileri</h6>
                    <Row>
                        <Col md={6}>
                            <p><strong>Marka:</strong> {formData.preferredVehicleBrand}</p>
                            <p><strong>Model:</strong> {formData.preferredVehicleModel}</p>
                        </Col>
                        <Col md={6}>
                            <p><strong>Model Yılı:</strong> {formData.vehicleYear}</p>
                            <p><strong>Peşinat:</strong> ₺{formData.downPayment}</p>
                        </Col>
                    </Row>
                </div>

                <div className="summary-item mt-3">
                    <h6><FaHome className="me-2" /> Finansman Bilgileri</h6>
                    <Row>
                        <Col md={6}>
                            <p><strong>Araç Bedeli:</strong> ₺{vehicleAmount.toLocaleString('tr-TR')}</p>
                            <p><strong>Aylık Ödeme:</strong> ₺{monthlyPayment.toLocaleString('tr-TR')}</p>
                        </Col>
                        <Col md={6}>
                            <p><strong>Vade:</strong> {term} Ay</p>
                        </Col>
                    </Row>
                </div>
            </div>

            <Form.Group className="mb-3">
                <Form.Label>Ek Notlar / İstekler</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={3}
                    name="notes"
                    value={formData.notes}
                    onChange={handleChange}
                    placeholder="Başvurunuzla ilgili belirtmek istediğiniz diğer hususlar"
                />
            </Form.Group>

            {/* Modern Black Theme Checkboxes */}
            <div className="mb-4">
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="hasAcceptedTerms"
                        name="hasAcceptedTerms"
                        checked={formData.hasAcceptedTerms}
                        onChange={handleChange}
                        required
                    />
                    <label className="form-check-label" htmlFor="hasAcceptedTerms">
                        Kişisel verilerimin işlenmesine ilişkin{' '}
                        <a
                            href="/kvkk-aydinlatma-formu"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            aydınlatma metnini
                        </a>{' '}
                        okudum ve anladım.
                    </label>
                </div>

                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="hasAcceptedCommunication"
                        name="hasAcceptedCommunication"
                        checked={formData.hasAcceptedCommunication}
                        onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="hasAcceptedCommunication">
                        Otoprime'dan kampanya, fırsat ve duyuruları e-posta ve SMS yoluyla almak istiyorum.
                    </label>
                </div>
            </div>

            <div className="d-flex justify-content-between">
                <Button variant="outline-secondary" onClick={handlePrev}>
                    Geri Dön
                </Button>
                <Button
                    variant="primary"
                    type="submit"
                    size="lg"
                    disabled={isSubmitting || !formData.hasAcceptedTerms}
                >
                    {isSubmitting ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Başvuru İşleniyor...
                        </>
                    ) : (
                        "Başvuruyu Tamamla"
                    )}
                </Button>
            </div>
        </div>
    );
};

export default ConfirmationForm;